import React from "react";
import { Save } from "lucide-react";

const FooterForm = ({ footerData, setFooterData, onSave }) => {
  const cardCls = "bg-white rounded-xl shadow p-8 mb-10";
  const labelCls = "block text-sm font-medium text-gray-700 mb-1";
  const inputCls =
    "w-full border rounded-lg px-3 py-2 shadow-sm focus:ring-2 focus:ring-blue-400 outline-none";
  const textareaCls =
    "w-full border rounded-lg px-3 py-2 shadow-sm focus:ring-2 focus:ring-blue-400 outline-none resize-none";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFooterData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <section className={cardCls}>
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold text-blue-700">
          Footer Settings
        </h2>
        <button
          onClick={onSave}
          className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
        >
          <Save size={18} /> Save
        </button>
      </div>

      {/* Company Info */}
      <div className="space-y-4 mb-8">
        <label className={labelCls}>Company Description</label>
        <textarea
          name="company_description"
          value={footerData.company_description || ""}
          onChange={handleChange}
          className={textareaCls}
          placeholder="e.g., HPR Infra – Building South India’s Future."
          rows={3}
        />
      </div>

      {/* Contact Info */}
      <div className="grid sm:grid-cols-2 gap-6 mb-8">
        <div>
          <label className={labelCls}>Address</label>
          <textarea
            name="address"
            value={footerData.address || ""}
            onChange={handleChange}
            className={textareaCls}
            placeholder="e.g., Road No. 12, Banjara Hills, South India"
            rows={3}
          />
        </div>
        <div className="space-y-4">
          <div>
            <label className={labelCls}>Phone 1</label>
            <input
              type="text"
              name="phone"
              value={footerData.phone || ""}
              onChange={handleChange}
              className={inputCls}
              placeholder="e.g., +91 9876543210"
            />
          </div>

          <div>
            <label className={labelCls}>Phone 2</label>
            <input
              type="text"
              name="phone1"
              value={footerData.phone1 || ""}
              onChange={handleChange}
              className={inputCls}
              placeholder="e.g., +91 9403188116"
            />
          </div>
          <div>
            <label className={labelCls}>Email</label>
            <input
              type="email"
              name="email"
              value={footerData.email || ""}
              onChange={handleChange}
              className={inputCls}
              placeholder="e.g., info@hprinfra.com"
            />
          </div>
        </div>
      </div>

      {/* Social Media Links */}
      <div className="space-y-4 mb-8">
        <h3 className="text-lg font-semibold text-gray-800">
          Social Media Links
        </h3>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
          <div>
            <label className={labelCls}>Facebook</label>
            <input
              type="url"
              name="facebook_url"
              value={footerData.facebook_url || ""}
              onChange={handleChange}
              className={inputCls}
              placeholder="https://www.facebook.com/hprinfra"
            />
          </div>

          <div>
            <label className={labelCls}>Instagram</label>
            <input
              type="url"
              name="twitter_url"
              value={footerData.twitter_url || ""}
              onChange={handleChange}
              className={inputCls}
              placeholder="https://www.instagram.com/hprinfra"
            />
          </div>

          <div>
            <label className={labelCls}>LinkedIn</label>
            <input
              type="url"
              name="linkedin_url"
              value={footerData.linkedin_url || ""}
              onChange={handleChange}
              className={inputCls}
              placeholder="https://www.linkedin.com/company/hprinfra"
            />
          </div>

          <div>
            <label className={labelCls}>YouTube</label>
            <input
              type="url"
              name="youtube_url"
              value={footerData.youtube_url || ""}
              onChange={handleChange}
              className={inputCls}
              placeholder="https://www.youtube.com/hprinfra"
            />
          </div>
        </div>
      </div>

      {/* Legal and Footer Note */}
      <div className="space-y-4">
        <div>
          <label className={labelCls}>Disclaimer</label>
          <textarea
            name="disclaimer_text"
            value={footerData.disclaimer_text || ""}
            onChange={handleChange}
            className={textareaCls}
            rows={3}
            placeholder="e.g., All images are artistic impressions unless stated. Specifications and approvals are subject to change."
          />
        </div>
        <div>
          <label className={labelCls}>Copyright / Footer Note</label>
          <input
            type="text"
            name="copyright_note"
            value={footerData.copyright_note || ""}
            onChange={handleChange}
            className={inputCls}
            placeholder="© 2025 HPR Infra. All Rights Reserved."
          />
        </div>
      </div>
    </section>
  );
};

export default FooterForm;
